import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const getPlannerHideColumnsAPI = createApi("GetPlannerHideColumns","GET");

const GetPlannerHideColumns = createSlice({
  name: 'GetPlannerHideColumns',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPlannerHideColumnsAPI.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPlannerHideColumnsAPI.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getPlannerHideColumnsAPI.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default GetPlannerHideColumns.reducer;